import { render, staticRenderFns } from "./TheInput.vue?vue&type=template&id=3bd06e4c&"
import script from "./TheInput.vue?vue&type=script&lang=js&"
export * from "./TheInput.vue?vue&type=script&lang=js&"
import style0 from "./TheInput.vue?vue&type=style&index=0&id=3bd06e4c&prod&coped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports